import React from 'react'
import SupportPrivacyPolicy from '../support-privacy-policy'

const SupportPrivacyPolicyPt = () => {
    return <SupportPrivacyPolicy languageCode="pt" />
}

export default SupportPrivacyPolicyPt
